module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-18-087902ce8d00eb1a70df4c972b46ea4c.svg";